import { connectHook } from 'app/common/components/connect-hook';
import { SettingsNav } from './settings-nav';
import { useSettingsNav } from './settings-nav-hook';

export default connectHook(SettingsNav, useSettingsNav);
